module.exports = __webpack_public_path__ + "media/images/athletes/3342-0c8e017341730ca114734af577051a0a.png";